<header class="page-header module-header">
    <div class="header-left">
        <h1 class="module-title">{{ title }}</h1>
        <p class="module-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>

    <div class="header-actions">
        <ng-content select="[actions]"></ng-content>
        <ng-content></ng-content>
    </div>
</header>
